import React, {Component} from 'react';
import './ConsultoriaFinanceira.css';

export default class ConsultoriaFinanceira extends Component {
    render() {
        return (
            <div className="content">
                <h1 className="titulo">Consultoria Financeira</h1>
                <ul>
                    <li>Gestão interina;</li>
                    <li>Renegociação de Dívidas;</li>
                    <li>Gestão de Caixa e Terceirização do Setor Financeiro da Empresa gerando Relatórios e Dados para Tomada de Decisão;</li>
                    <li>Levantamento de Custos e Margens;</li>
                    <li>Projetos de Redução e Controle de Custos.</li>
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/ConsultoriaFinanceira.js